export default "__VITE_ASSET__BzJp0MaX__"